let csrf = "";

export function setCsrf(value: string) { csrf = value; }

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers);
  if (options.body && !(options.body instanceof FormData)) headers.set("Content-Type", "application/json");
  if (csrf && !["GET", "HEAD"].includes(options.method ?? "GET")) headers.set("X-CSRF-Token", csrf);
  const response = await fetch(`/api${path}`, { ...options, headers, credentials: "same-origin" });
  const data = await response.json().catch(() => ({ error: "Unexpected server response" }));
  if (!response.ok) throw new ApiError(data.error ?? "Request failed", response.status, data.code);
  return data as T;
}

export class ApiError extends Error {
  constructor(message: string, public status: number, public code?: string) { super(message); }
}

export function track(name: string, properties: Record<string, string | number | boolean> = {}) {
  const body = JSON.stringify({ name, properties });
  if (navigator.sendBeacon) navigator.sendBeacon("/api/analytics", new Blob([body], { type: "application/json" }));
  else void fetch("/api/analytics", { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
}
